import React from 'react';

const A = () => {
    return (
        <div>
            <h1> my name is jony </h1>
        </div>
    );
};

export default A;